module.exports = __webpack_public_path__ + "media/images/icons/filled/wallet-449637edd47f221cf77ffb402d0373ef.svg";